import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=6d617a8e&scoped=true&"
import script from "./my-profile.vue?vue&type=script&lang=js&"
export * from "./my-profile.vue?vue&type=script&lang=js&"
import style0 from "./my-profile.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./my-profile.vue?vue&type=style&index=1&id=6d617a8e&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6d617a8e",
  null
  
)

export default component.exports